import {
  GET_ALL_VIDEO_REQUEST,
  GET_ALL_VIDEO_SUCCESS,
  GET_ALL_VIDEO_FAILURE,
} from "./actionTypes";

const initialState = {
  ISLOADING: false, // Fixed typo (was "ISlOADING")
  ALL_VIDEO_LIST: [], 
  ISFAILURE: false,
};

export  function ALL_VIDEO_LISTreducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_VIDEO_REQUEST:
      return { ...state, ISLOADING: true }; // Fixed typo
    case GET_ALL_VIDEO_SUCCESS:
      return {
        ...state,
        ALL_VIDEO_LIST: payload.records, // Updated key to match VIDEO-related data
        ISLOADING: false,
      };
    case GET_ALL_VIDEO_FAILURE:
      return { ...state, ISFAILURE: true, ISLOADING: false };
    default:
      return state;
  }
}
